import React, { useEffect, useState } from "react";
import { About } from "../../Assets.tsx";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const AboutUs = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useGSAP(() => {
    if (!isMobile) {
    gsap.from(".aboutUs h1", {
        opacity: 0,
        duration: 2,
        x: 500,
        scrollTrigger: {
          trigger: ".aboutUs h1",
          scroller: "body",
          markers: false,
          start: "top 50%",
        },
      });
    }
  });
  return (
    <div style={webstyle.container} className="about-us-bg-img" id="about-us">
      <div style={{ width: "50%" }} className="aboutuscontainer  aboutUs">
        <h1 style={{ ...webstyle.title, textAlign: "center" }}>About Us</h1>
        <p style={{ ...webstyle.subtitle, textAlign: "center" }}>
          KAMDHENU PARK IN PUNE
        </p>
        <p style={webstyle.aboutUsParagraph}>
        Kamdhenu Developers Estate stand as pillars of excellence in the real estate sector, committed to providing the highest quality of living and development. Our projects aim to blend luxury, comfort, and sustainability, catering to the diverse needs of homebuyers and investors.
        </p>
        <p style={webstyle.aboutUsParagraph}>
        Nestled in a serene and green environment, Kamdhenu Park is designed for those who seek tranquility and sophistication. With state-of-the-art amenities, well-planned architecture, and lush surroundings, Kamdhenu Park is more than just a home—it's a lifestyle choice. Whether you are looking for a modern apartment, spacious villa, or a peaceful retreat, we offer various options that meet your expectations.
        </p>
      </div>
    </div>
  );
};

const webstyle = {
  container: {
    background: `url(${About}) no-repeat center center/cover`,
    height: "720px",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // margin: "50px 0 0 0 ",
    borderTop: "3px solid orange",
    borderBottom: "3px solid orange",
  },
  aboutUsParagraph: {
    color: "lightgray",
    fontSize: "18px",
  },
  title: {
    color: "orange",
    textAlign: "center",
    fontSize: "60px",
  },
  subtitle: {
    color: "white",
    fontWeight: 700,
    textAlign: "center",
    fontSize: "35px",
  },
};
export default AboutUs;
